import { useMaterialFontReady } from "../../hooks/useMaterialFontReady";

const FONT_CLASS_MAP = {
  outlined: "material-symbols-outlined",
  rounded: "material-symbols-rounded",
  sharp: "material-symbols-sharp"
};

const MaterialIcon = ({
  name,
  className = "",
  style = {},
  title = "",
  decorative = true,
  type = "outlined", // new prop: 'outlined' | 'rounded' | 'sharp'
  ...rest
}) => {
  // const isFontReady = true;
  const isFontReady = useMaterialFontReady(type);

  const fontClass = FONT_CLASS_MAP[type] || FONT_CLASS_MAP.outlined;

  if (!isFontReady) {
    return (
      <span
        aria-hidden="true"
        style={{
          display: "inline-block",
          width: "1em",
          height: "1em",
          verticalAlign: "middle",
          backgroundColor: "transparent",
          ...style
        }}
        className={className}
        {...rest}
      />
    );
  }

  return (
    <span
      className={`${fontClass} ${className}`}
      style={style}
      {...rest}
      aria-hidden={decorative ? "true" : undefined}
      role={decorative ? undefined : "img"}
      title={decorative ? undefined : title}
    >
      {name}
    </span>
  );
};

export default MaterialIcon;
